import type { Handler } from './handler';
import type { ApiPostDailyCheckinClaimPort } from './ports/api-post-daily-checkin-claim.port';
import type { DailyCheckinClaimResult } from '~/types/daily-checkin';
import { resolveAdapter } from '~/adapters/registry';

// POST /daily-check-in/claim. Não recebe qual degrau resgatar nem quem resgata:
// o degrau é decisão do servidor e o jogador é o dono do token.
export const postDailyCheckinClaimHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  _params,
  ports = {
    apiPostDailyCheckinClaim: resolveAdapter('apiPostDailyCheckinClaim'),
  },
) => {
  return await ports.apiPostDailyCheckinClaim.handle();
};

type Params = void;

type Ports = { apiPostDailyCheckinClaim: ApiPostDailyCheckinClaimPort };

type Result = Promise<DailyCheckinClaimResult>;
